import L from "leaflet";
import { onDocumentReady } from "@story/story_assets/utils";

const API_KEY = 'IQHAPcZKGs3GLhaRIKuCT25kZqKQAhwI0tLEtyg4YLA';

function addHomeMarker(map, size) {
	const iconSize = size !== "lg" ? 25 : 30;
	const iconClass = size !== "lg" ? "map-trip-pin-height-25" : "map-trip-pin-height-30";
	const logoUrl = RAILS_ASSET_URL("/logo.svg");

	const html = `
		<div class="map-trip-pin-wrapper">
			<div class="map-trip-pin map-trip-pin-home">
				<div class="row no-gutters flex-nowrap">
					<div class="col-auto">
						<img src="${logoUrl}" alt="" height="${iconSize}" class="${iconClass}">
					</div>
					<div class="col">
						<div class="title">Úbislavice</div>
					</div>
				</div>
			</div>
		</div>
	`;

	const icon = L.divIcon({
		html,
		iconSize: [null, null],
		iconAnchor: [0, 12],
	});

	L.marker([50.4771028, 15.4635544], {
		icon,
		title: "Jínův statek",
	}).addTo(map);
}

onDocumentReady(() => {
	const mapElement = document.querySelector("#map");
	if (!mapElement) {
		return;
	}

	const position = [50.4771028, 15.4635544];
	const zoom = 11;

	const map = L.map(mapElement).setView(position, zoom);
	map.attributionControl.setPrefix(false);

	L.tileLayer(`https://api.mapy.cz/v1/maptiles/basic/256@2x/{z}/{x}/{y}?apikey=${API_KEY}`, {
		minZoom: 0,
		maxZoom: 19,
		attribution: '<a href="https://api.mapy.cz/copyright" target="_blank">&copy; Seznam.cz a.s. a další</a>',
	}).addTo(map);

	addHomeMarker(map, "lg");
});

onDocumentReady(() => {
	const mapElement = document.querySelector("#map-trips");
	if (!mapElement) {
		return;
	}

	const position = [49.8, 15.3386383];
	const zoom = 7;

	const map = L.map(mapElement).setView(position, zoom);
	map.attributionControl.setPrefix(false);

	L.tileLayer(`https://api.mapy.cz/v1/maptiles/basic/256@2x/{z}/{x}/{y}?apikey=${API_KEY}`, {
		minZoom: 0,
		maxZoom: 19,
		attribution: '<a href="https://api.mapy.cz/copyright" target="_blank">&copy; Seznam.cz a.s. a další</a>',
	}).addTo(map);

	// Home
	addHomeMarker(map);

	// Destinations
	const trips = JSON.parse(mapElement.getAttribute("data-trips"));
	for (let i = 0; i < trips.length; ++i) {
		const trip = trips[i];
		for (let j = 0; j < trip.destinations.length; ++j) {
			const destination = trip.destinations[j];
			if (destination.latitude && destination.longitude) {
				// Create marker for given destination
				let animalIcons = "";
				if (trip.is_for_horses) {
					animalIcons += `<img src="${RAILS_ASSET_URL("/icons/icon-horse-ocre.svg")}" alt="" height="25" class="map-trip-pin-height-25">`;
				}
				if (trip.is_for_dogs) {
					animalIcons += `<img src="${RAILS_ASSET_URL("/icons/icon-dog-ocre.svg")}" alt="" height="20" class="map-trip-pin-height-20">`;
				}

				const html = `
					<div class="map-trip-pin-wrapper">
						<div class="map-trip-pin map-trip-pin-home">
							<div class="row no-gutters flex-nowrap">
								<div class="col-auto">${animalIcons}</div>
								<div class="col">
									<div class="date">${trip.formatted_date}</div>
									<div class="title">${destination.title}</div>
								</div>
							</div>
						</div>
					</div>
				`;

				// map.addMarker(destination.latitude, destination.longitude, trip.date, {
				// 	url: pin,
				// 	anchor: { right: 0, top: 12 }
				// });

				const icon = L.divIcon({
					html,
					iconSize: [null, null],
					iconAnchor: [-1, 12],
				});

				L.marker([destination.latitude, destination.longitude], {
					icon,
					title: "Jínův statek",
				}).addTo(map);

			}
		}
	}
});
